import React from 'react';
import {
    IconBandage,
    IconBaseballCap,
    IconBathtub,
    IconBeach,
    IconCable,
    IconCleaning,
    IconComputer,
    IconCooking,
    IconDryer,
    IconFirePlaceGas,
    IconFirePlaceOutdoor,
    IconFirePlaceWood,
    IconHeating,
    IconHotTub,
    IconLinens,
    IconPingPong,
    IconPool,
    IconRecycle,
    IconSauna,
    IconSurfboard,
    IconWireCheckBox,
    IconWirePacifier,
    IconWireSkis,
    IconWireSoundHigh,
    IconWireWoodStove,
} from '../../assets/icons';

export const CategoryIcons: { [key: string]: any } = {
    beach_access: <IconBeach />,
    private_beach: <IconBeach />,
    bathroom_features: <IconBathtub />,
    bedding: <IconLinens />,
    washer_dryer: <IconDryer />,
    cleaning: <IconCleaning />,
    garbage_recycling: <IconRecycle />,
    heating_cooling: <IconHeating />,
    indoor_recreation: <IconPingPong />,
    kids: <IconBaseballCap />,
    kitchen: <IconCooking />,
    safety: <IconBandage />,
    technology_office: <IconComputer />,
    media: <IconCable />,
    hot_tub: <IconHotTub />,
    fireplace: <IconFirePlaceOutdoor />,
    gas_fireplace: <IconFirePlaceGas />,
    wood_fireplace: <IconFirePlaceWood />,
    pool: <IconPool />,
    indoor_pool: <IconPool />,
    heated_pool: <IconPool />,
    ski_in_ski_out: <IconWireSkis />,
    wood_stove: <IconWireWoodStove />,
    sauna: <IconSauna />,
    outdoor_recreation: <IconSurfboard />,
    home_audio: <IconWireSoundHigh />,
    baby: <IconWirePacifier />,
    default: <IconWireCheckBox />,
};
